/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { Item } from '../utils/UNSAFE_dataProvider';
import { Logger } from '../utils/UNSAFE_logger';
import { ItemTextFunctionType, ItemTextType } from '../utils/UNSAFE_selectUtils';

export function renderItemText<K, D>(item: Item<K, D>, itemText: ItemTextType<K, D>) {
  // if item-text is a string and the data has the specified field, return it;
  // otherwise log an error
  if (typeof itemText === 'string') {
    if ((item.data as any)?.hasOwnProperty(itemText)) {
      const retData = item.data[itemText];
      return String(retData);
    }
    Logger.error('SelectMultiple: itemText specifies field that does not exist: ' + itemText);
    // return undefined if the field doesn't exist
    return undefined;
  }
  // if item-text is a function, call it to create a display label
  return (itemText as ItemTextFunctionType<K, D>)(item);
}
